import api from './api';

export const getAddresses = async () => {
  const response = await api.get('/admin/addresses/');
  return response.data;
};

export const createAddress = async (data) => {
  const response = await api.post('/addresses/', data);
  return response.data;
};

export const updateAddress = async (id, data) => {
  const response = await api.put(`/addresses/${id}/`, data);
  return response.data;
};

export const deleteAddress = async (id) => {
  const response = await api.delete(`/addresses/${id}/`);
  return response.data;
};

export const getCountries = async () => {
  const response = await api.get('/admin/countries/');
  return response.data;
};

export const getStates = async (params = {}) => {
  let url = '/admin/states/';
  if (params.country_id) {
    url += `?country_id=${params.country_id}`;
  }
  const response = await api.get(url);
  return response.data;
};

export const getCities = async (params = {}) => {
  let url = '/admin/cities/';
  if (params.state_id) {
    url += `?state_id=${params.state_id}`;
  }
  const response = await api.get(url);
  return response.data;
}; 
